import { createContext, type ReactNode, use } from "react";

// Who looks at the screen, as the app read it (its `/auth/me`), for the screen packages of the domains (ADR-166):
// they hide what the user cannot do, and the gateway and the domain check again. Each app sets it once, in its frame.

export interface Viewer {
  /** Tomorrow's users: the rules on who edits when distinguish them; never true in Atelier. */
  isInternal: boolean;
  permissions: readonly string[];
}

const ViewerContext = createContext<Viewer | null>(null);

export function ViewerProvider({ value, children }: { value: Viewer; children: ReactNode }) {
  return <ViewerContext value={value}>{children}</ViewerContext>;
}

export function useViewer(): Viewer {
  const viewer = use(ViewerContext);
  if (!viewer) throw new Error("A screen package outside ViewerProvider");
  return viewer;
}

export function useViewerCan(permission: string): boolean {
  return useViewer().permissions.includes(permission);
}
